An array of locations where the position is based.

This field is limited to a single element.
